import React, { useEffect } from 'react';
import { ToastContainer } from "react-toastify";
import { Provider, useDispatch } from "react-redux";
import { ModalContainer } from "components/style-guide/modal/ModalContainer";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import reducers from "../store";
import { fetchOffers } from "pages/home/store";
import StorageService from 'service/storage';
import { UtilConst } from 'settings/data';

const queryString = require("query-string");

//capture referal_code from uri
const query = queryString.parse(document.location.search);

if (query?.referral) {
    StorageService.setItem(UtilConst.ls_referral_code, query.referral)
}
//end

const configureStore = rootReducer => (
    createStore(
        rootReducer,
        process.env.NODE_ENV !== 'production'
            ? composeWithDevTools(applyMiddleware(thunk))
            : applyMiddleware(thunk)
    )
);

const store = configureStore(reducers);

export const AppProviders = ({ children }) => {

    return (
        <Provider store={store}>
            <div className="app-container">
                {children}
                <AppProvidersChild />
            </div>
            <ToastContainer />
            <ModalContainer />
        </Provider>
    );
};

export const AppProvidersChild = ({ children }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchOffers());
    }, [])

    return <></>;
};
